<app-snackbar></app-snackbar>
<div class="w-100 h-100">
	<div class="header-height">
		<!-- Title loader -->
		<div class="pad-L" *ngIf="_loading || _initializing" style="height: 37px">
			<app-title-content-loader></app-title-content-loader>
		</div>

		<div class="pad-L slider-header" *ngIf="!_loading && !_initializing" >
			<div class="flex gap-S" [style.width.px]="settings ? 500 : 563">
				<!-- TITLE -->
				<div class="flex-align-center gap-S" style="max-width: 50%;">
					<app-display-logo [logo]="application.logo" [size]="45"></app-display-logo>
					<span class="font-M fw-700 primary text-overflow-ellipsis">{{ application.name }}</span>
				</div>
				<!-- TAGS -->
				<div class="flex-align-center gap-XS w-100" style="min-width: 48%; max-width: 98%;">
					<app-multi-select
						[addMinHeight]="true"
						[inputControl]="tagsControl" multiple
						[disabled]="_initializing || _savingTag"
						[enableDeleteMode]="true"
						[confirmButton]="false"
						(deleteSelected)="onDeleteTags($event)">
						<div *ngIf="tagsControl.value.length > 0 && isEditor" class="flex-align-center c-p" select-trigger style="height: 38px;">
							<div *ngIf="tagsControl.value.length > 0" class="add-tag-button flex-center" [tooltip]="'global.adds.tag' | translate">
								<img src="assets/icons/add.svg" class="filter-primary" width="10">
							</div>
						</div>
						<div *ngIf="tagsControl.value.length <= 0 && isEditor" class="flex-align-center c-p" select-trigger style="height: 38px;">
							<div class="single-tag flex-center pad-0-S gap-XS">
								<img src="assets/icons/add.svg" width="10" class="filter-primary">
								<span>{{ 'global.adds.tag' | translate }}</span>
							</div>
						</div>
						<app-select-search [searchControl]="searchTagControl"></app-select-search>
						<app-select-insert [saving]="_savingTag"
										   [searchTerm]="searchTagControl.value"
										   [titlePath]="'global.multiSelect.createTagHeader'"
										   [titlePathSearchNoResult]="'global.multiSelect.createTagHeaderNoResult'"
										   [noResults]="filteredTagList.length === 0 && searchTagControl.value?.length > 0"
										   (create)="createTag($event)"></app-select-insert>
						<app-select-option *ngFor="let tag of filteredTagList" [value]="tag" class="tag-option">
							<div class="flex-space-between flex-align-center w-100 h-100">
								<span>{{tag.name}}</span>
								<span *ngIf="tag.countOfApplications > 0" class="grey font-S used-count">{{ 'global.multiSelect.usedXTimes' | translate: {count: tag.countOfApplications} }}</span>
							</div>
						</app-select-option>
					</app-multi-select>
					<div class="tag-container flex-align-center gap-XS">
						<ng-container *ngFor="let tag of tagsControl.value | slice:0:2; index as i">
							<div class="single-tag flex-center pad-0-S gap-XS p-relative tag-item" style="cursor:default;">
								<span class="tag-text">{{ tag.name }}</span>
								<div *ngIf="isEditor" style="right: -4px; top: -4px" class="remove-tag-button flex-center c-p p-absolute" (click)="$event.stopPropagation();onRemoveTag(tag);">
									<img src="assets/icons/close.svg" width="7" class="filter-white">
								</div>
							</div>
						</ng-container>
						<div *ngIf="tagsControl.value.length > 2" class="single-tag flex-center pad-0-S gap-XS tag-counter" [tooltipTriggerFor]="tagsTooltip" style="cursor:default;">
							<span class="font-S fw-500">+{{ tagsControl.value.length - 2 }}</span>
						</div>
					</div>
					<app-tooltip #tagsTooltip>
						<div *ngFor="let tag of tagsControl.value" class="flex-align-center gap-XS">
							<span>{{ tag.name }}</span>
						</div>
					</app-tooltip>
				</div>
			</div>

			<div class="flex-align-center gap-S">
				<app-icon-button type="stroked" background [img]="'assets/icons/close-drawer.svg'"
								 (click)="close()">
				</app-icon-button>
				<app-icon-button type="stroked" background [img]="'assets/icons/save.svg'"
								 *ngIf="!!settings && isEditor"
								 (click)="onSaveSettings()">
				</app-icon-button>
				<div style="position: relative">
					<div *ngIf="unreadCommentsNotifications > 0" class="unread-notifications"></div>
					<div *ngIf="unreadCommentsNotifications == 0 && commentsCount > 0" class="total-comments flex-center">
						<span class="font-S fw-700">{{ commentsCount < 10 ? commentsCount : '9+' }}</span>
					</div>
					<app-icon-button type="stroked" background [img]="!comments ? 'assets/icons/comment-inactive.svg' : 'assets/icons/comment-active.svg'"
									 [focused]="!!comments"
									 (click)="onOpenAppComments()">
					</app-icon-button>
				</div>
				<app-icon-button type="stroked" background [img]="!settings ? 'assets/icons/cog-inactive.svg' : 'assets/icons/cog-active.svg'"
								 [focused]="!!settings"
								 *ngIf="isEditor"
								 (click)="onOpenAppSettings()">
				</app-icon-button>
				<app-icon-button type="stroked" background color="danger" [img]="'assets/icons/trash.svg'"
								 *ngIf="isEditor"
								 (click)="onOpenDeleteAppPopup()">
				</app-icon-button>
			</div>
		</div>
	</div>

	<div *ngIf="!!settings || !!comments" [ngClass]="{'settings-triangle': !!settings, 'comments-triangle': !!comments && isEditor, 'comments-triangle-read-only': !!comments && !isEditor}"></div>

	<div class="content-height border-box overflow-y above-triangle">
		<app-tabs-group [hidden]="!!settings || !!comments"
						[selectedIndex]="sliderIndex"
						(selectedIndexChange)="onSliderChange($event)">

			<!-- Tab Overview -->
			<app-tab [icon]="'overview'" label="{{ 'menu.overview2' | translate }}">
				<div *ngIf="lazyLoadedTabs[0]" class="flex-column gap-XL" style="margin-top: 17px;">
					<app-overview-tab [tabActive]="sliderIndex === 0 && !settings && !comments"></app-overview-tab>
				</div>
			</app-tab>

			<!-- Tab Operations -->
			<app-tab [icon]="'operations'" label="{{ 'menu.overview' | translate }}">
				<div *ngIf="lazyLoadedTabs[1]" class="flex-column gap-XL" style="margin-top: 17px;">
					<app-operation-tab></app-operation-tab>
				</div>
			</app-tab>

			<!-- Tab Finance -->
			<app-tab [icon]="'finance'" label="{{ 'menu.finance' | translate }}">
				<div *ngIf="lazyLoadedTabs[2]" class="flex-column gap-XL" style="margin-top: 17px;">
                    <app-finance-tab></app-finance-tab>
				</div>
			</app-tab>

			<!-- Tab Usage -->
			<app-tab [icon]="'usage'" [badge]="autodiscoveredTeamsCount > 0 && displayAutodiscoverTeamsNotification ? autodiscoveredTeamsCount.toString() : undefined" label="{{ 'menu.usage' | translate }}">
				<div *ngIf="lazyLoadedTabs[3]" class="flex-column gap-XL" style="margin-top: 17px;">
					<app-usage-tab (autodiscoveredTeamsChanged)="onAutodiscoverTeamsChanged($event)" (autodiscoveredTeamsSeen)="setLocalStorageTeamsCount()"></app-usage-tab>
				</div>
			</app-tab>

			<!-- Tab Architecture -->
			<app-tab [icon]="'architecture'" label="{{ 'menu.architecture' | translate }}">
				<div *ngIf="lazyLoadedTabs[4]" class="flex-column gap-XL" style="margin-top: 17px;">
					<app-architecture-tab></app-architecture-tab>
				</div>
			</app-tab>

			<app-tab [icon]="'data'" label="{{ 'menu.data' | translate }}">
				<div *ngIf="lazyLoadedTabs[5]" class="flex-column gap-XL" style="margin-top: 17px;">
					<app-application-data-tab></app-application-data-tab>
				</div>
			</app-tab>
		</app-tabs-group>

		<app-application-comments *ngIf="!!comments"
								  (onCommentsCountChange)="commentsCount = $event"></app-application-comments>

		<app-application-settings *ngIf="!!settings && isEditor"></app-application-settings>
	</div>
</div>
